import { ChangeDetectionStrategy, Component, input, model, InputSignal, output, computed } from '@angular/core';
import { UBaseInfraComponent } from '../u-base-infra.component';
import type { AbstractControl, FormControl } from '@angular/forms';
import type { MatCheckboxChange } from '@angular/material/checkbox';

export interface CheckboxItem<T = any> {
  label: string;
  value: T;
  disabled?: boolean;
}

export interface UCheckboxChange {
  checked: boolean;
  value?: string;
  originalEvent?: HTMLElement;
}

@Component({
  selector: 'u-checkbox',
  templateUrl: './u-checkbox.component.html',
  styleUrls: ['./u-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UCheckboxComponent extends UBaseInfraComponent {
  readonly label: InputSignal<string> = input('');
  readonly value: InputSignal<string> = input('');
  readonly binary: InputSignal<boolean> = input(false);
  readonly formControl: InputSignal<AbstractControl | null> = input(null, { alias: 'fieldFormControl' });
  readonly fieldFormControl = computed<FormControl | null>(() => this.formControl() as FormControl | null);

  checked = model<boolean>(false);
  selectedValues = model<CheckboxItem[]>();

  onChange = output<UCheckboxChange>();

  readonly isChecked = computed(() => {
    if (this.binary()) {
      return this.checked();
    } else {
      return this.selectedValues()?.some((item) => item.value === this.value()) || false;
    }
  });

  onCheckboxChange(event: MatCheckboxChange) {
    const isChecked = event.checked;
    this.checked.set(isChecked);

    if (!this.binary() && this.value()) {
      const checkboxItem: CheckboxItem = {
        value: this.value(),
        label: this.label(),
      };

      if (isChecked) {
        this.selectedValues.update((current) => [...(current || []), checkboxItem]);
      } else {
        this.selectedValues.update((current) => (current || []).filter((v) => v.value !== this.value()));
      }
    }

    this.onChange.emit({
      checked: isChecked,
      value: this.value() || undefined,
      originalEvent: event.source?._elementRef?.nativeElement,
    });
  }

  onCheckboxClick(event: MouseEvent) {
    event.stopPropagation();
  }

  getIconRef() {
    return null;
  }
}
